import { connect } from 'react-redux';
import MaintenanceDashboardModal from '../../components/MaintenanceDashboardModal/MaintenanceDashboardModal';
import { setMaintenanceDashboardModalVisibility } from '../../actions/DashboardActions';

const mapStateToProps = (state) => ({
  open: state.leaksList.dashboard.maintenanceDashboardModalVisible,
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(setMaintenanceDashboardModalVisibility(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceDashboardModal);
